<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (onRefresh)="onReset()"
>
  <div class="card-toolbar" after-btns>
    <!-- close -->
    <a
      class="btn btn-light txt-lg button-shadow mx-1 btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.back' | translate"
      (click)="onClose()"
    >
      <i class="mdi mdi-arrow-left mdi-20px p-0"></i>
    </a>
  </div>

  <div class="tw-flex tw-justify-between tw-items-center tw-ml-5" title>
    (
    <span
      class="tw-font-medium tw-text-base tw-text-gray-700 dark:tw-text-gray-300"
      >{{ "common.title" | translate }} :
    </span>
    <span
      copyToClipboard
      class="text-navyBlue tw-py-1 rounded tw-text-xl tw-mr-2 tw-font-semibold"
      >{{ campaignTitle }}</span
    >
    )
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="items && !pageConfig.loading">
    <ng-container *ngFor="let item of items; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        class="ml-2"
      >
        <!-- index -->
        <td class="px-4 text-center py-2">
          {{ this.paginationModel.firstIndex + i }}
        </td>

        <!-- grayListId -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.grayListId"
          ></td-value>
        </td>

        <!-- operator -->
        <td class="tw-py-2">
          <div
            class="tw-flex-center"
            [matTooltip]="item?.operator | enumToText : SmsAggregatorEnumValues"
            [mobileOperatorImg]="{
              mobileOperator: item?.operator,
              mobileOperatorEnumValue:
                item?.operator | enumToText : SmsAggregatorEnumValues
            }"
          ></div>
        </td>

        <!-- isCreated -->
        <td>
          <td-value type="boolean" [value]="item?.isCreated"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td class="sticky-td">
          <a
            (click)="onAddSmartSmsCampaignToGateway(item?.operator)"
            class="btn btn-sm tw-ml-3"
            matTooltip="{{ 'common.retry' | translate }}"
          >
            <i class="mdi mdi-plus-thick mdi-20px text-info"></i>
          </a>
        </td>
        
      </tr>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!items?.length" table-body>
    <tr>
      <td colspan="100">
        <p
          class="text-center tw-text-gray-500 dark:tw-text-gray-300 my-5 text-lg dir"
        >
          {{ "common.empty" | translate }}
        </p>
      </td>
    </tr>
  </ng-container>
</app-page-template>
